import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  cihazOlaylariListele,
  cihazAnahtarlariListele,
  cihazAnahtariOlustur,
  cihazAnahtariIptal,
  type CihazAnahtariOlusturIstegi,
  type CihazOlayiSorgusu,
  type SayfalanmisCihazOlaylari,
} from '@emanetx/sdk';
import { istemci } from '../istemci.js';

export function useCihazOlaylariListesi(
  sorgu: Partial<CihazOlayiSorgusu>,
  yenilemeAraligi = 15_000,
) {
  return useQuery<SayfalanmisCihazOlaylari>({
    queryKey: ['cihaz-olaylari', sorgu],
    queryFn: () => cihazOlaylariListele(istemci, sorgu),
    placeholderData: (onceki) => onceki,
    refetchInterval: yenilemeAraligi > 0 ? yenilemeAraligi : false,
  });
}

// ===== Raspi API anahtarlari =====
const ANAHTAR_QK = (noktaId: string) => ['cihaz-anahtarlari', noktaId] as const;

export function useCihazAnahtarlari(noktaId: string) {
  return useQuery({
    queryKey: ANAHTAR_QK(noktaId),
    queryFn: () => cihazAnahtarlariListele(istemci, noktaId),
    enabled: !!noktaId,
  });
}

export function useCihazAnahtariOlustur(noktaId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (giris: CihazAnahtariOlusturIstegi) =>
      cihazAnahtariOlustur(istemci, noktaId, giris),
    onSuccess: () => qc.invalidateQueries({ queryKey: ANAHTAR_QK(noktaId) }),
  });
}

export function useCihazAnahtariIptal(noktaId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, sebep }: { id: string; sebep: string }) =>
      cihazAnahtariIptal(istemci, noktaId, id, sebep),
    onSuccess: () => qc.invalidateQueries({ queryKey: ANAHTAR_QK(noktaId) }),
  });
}
